<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="/stucollect">留学汇总</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>学校统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form inline label-position="right" label-width="80px" size="small" class="query-form">
        <el-form-item label="录入时间">
          <el-date-picker
            v-model="query.time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="yearSearch();"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="缴费时间">
          <el-date-picker
            v-model="query.paytime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="payYearSearch();"
          ></el-date-picker>
        </el-form-item>
          <SelectAbroad v-on:selabroad="function(str){query.abroadTime=str;getCollect();}"></SelectAbroad>
        <el-form-item label="学校">
          <el-select v-model="query.schid" filterable @change="schoolClick()">
            <el-option label="请选择" value></el-option>
            <el-option
              v-for="item in schoollist"
              :label="item.label"
              :value="item.value"
              :key="item.value"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="this.getCollect();">查询</el-button>
        </el-form-item>
      </el-form>
      <el-alert
        type="success"
        show-icon
        :closable="false"
        :title="schoolTitle"
        style="margin-top:0px;"
      ></el-alert>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-card class="box-card collectCard" shadow="always" style="margin-top:20px;">
            <div class="clearfix" slot="header">
              <span>Vip学生统计</span>
            </div>
            <div class="index-card" style="height:auto;">
              <div id="School" style="height:1000px;"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import "echarts/theme/macarons.js";
import url from "@/plugins/urlHelper.js";
import SelectAbroad from "@/components/SelectAbroad";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {
        time: [],
        paytime: []
      }, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      schoollist: [],
      schoolTitle: "选择学校查询学校的申请人数~"
    };
  },
    components: {
    SelectAbroad
  },
  methods: {
    //获取学校统计，地区统计
    getCollect() {
      //柱状图
      var link2 = url.getCollect("GetSchIndex");
      $.get(link2, this.query, data => {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(
          document.getElementById("School"),
          "macarons"
        );
        // 绘制图表
        myChart.setOption({
          title: {
            text: "学校申请人数排行",
            subtext: "数据来自Crm系统",
            x: "center"
          },

          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            }
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "value",
            boundaryGap: [0, 0.01]
          },
          yAxis: {
            type: "category",
            data: data.name.reverse()
          },
          series: [
            {
              name: "申请人数",
              type: "bar",
              data: data.value.reverse(),
              label: {
                normal: {
                  show: true,
                  position: "inside"
                }
              }
            }
          ]
        });
      });
    },
    //获取学校
    getSchool: function() {
      var _this = this;
      var link = url.getCommon("getschool");
      $.get(link, {}, data => {
        _this.schoollist = data;
      });
    },
    //月份选择
    yearSearch() {
      if(this.query.time){
      this.query.start = this.query.time[0];
      this.query.end = this.query.time[1];
      }else{
      this.query.start =undefined;
      this.query.end =undefined;
      }

      this.query.paystart = undefined;
      this.query.payend = undefined;
      this.query.paytime = [];
      this.getCollect();
    },
    //支付月份
    payYearSearch() {
      this.query.start = "";
      this.query.end = "";
      this.query.time = [];
      if(this.query.paytime){
  this.query.paystart = this.query.paytime[0];
      this.query.payend = this.query.paytime[1];
      }else{
  this.query.paystart =undefined;
      this.query.payend = undefined;
      }
    
      this.getCollect();
    },
    //按学校查询
    schoolClick: function() {
      var _this = this;
      var schid = this.query.schid;
      //获取人数
      var link = url.getCollect("getbysch");
      $.get(link, this.query, data => {
        _this.schoolTitle = "Crm系统当前时间内申请人数【" + data + "】人";
      });
    }
  },
  created() {},
  mounted() {
    this.getCollect();
    this.getSchool();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
